import { render, staticRenderFns } from "./ConfigTemplateApp.vue?vue&type=template&id=a19e1f76&scoped=true"
import script from "./ConfigTemplateApp.vue?vue&type=script&lang=js"
export * from "./ConfigTemplateApp.vue?vue&type=script&lang=js"
import style0 from "./ConfigTemplateApp.vue?vue&type=style&index=0&id=a19e1f76&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19e1f76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a19e1f76')) {
      api.createRecord('a19e1f76', component.options)
    } else {
      api.reload('a19e1f76', component.options)
    }
    module.hot.accept("./ConfigTemplateApp.vue?vue&type=template&id=a19e1f76&scoped=true", function () {
      api.rerender('a19e1f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/templateApp/ConfigTemplateApp.vue"
export default component.exports